/**
 * Json pretty format value, return value on syntax error
 */
export const jsonPrettySafe = (json: string): string => {
  try {
    return JSON.stringify(JSON.parse(json), null, 2);
  } catch (e) {
    return json;
  }
};